import { render } from "./OnboardingOverview.vue?vue&type=template&id=98b6557e"
import script from "./OnboardingOverview.vue?vue&type=script&lang=js"
export * from "./OnboardingOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__